<template>
    <div>
        <p class="stack-m">Add or remove customer's tags.</p>
        <div class="table-control">
            <table class="table">
                <tbody>
                    <tr v-for="(tagsArray, key) in tags" :key="key">
                        <td><strong>{{key | capitalize}}</strong></td>
                        <td>
                            <template v-for="tag in tags[key]">
                                <r-badge type="tag" class="inline-s" :key="tag">{{tag}}</r-badge>
                            </template>
                            <span v-if="!tags[key].length" > {{ $emptyInnerHTML() }} </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'tag-or-untag-customer-summary',
        extends: BaseActionSummary,

        computed: {
            tags() {
                return {
                    add: this.action.addingTags,
                    remove: this.action.removingTags,
                };
            },
        },
    };
</script>
